import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {LatLngBounds} from 'leaflet';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {checkLatValue, checkLonValue} from '../../dashboard-utility-functions';
import {ProjectBusinessLogicFilterModel} from '../../../shared/project-business-logic-filter/project-business-logic-filter.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardRegionGeofenceSumService {

  constructor(
    protected http: HttpClient
  ) {
  }

  private buildRegionGeofenceSumSearchKey(key: string): string {
    return `RegionGeofenceSumSearch[${key}]`;
  }

  public getItems(
    leafletBoundaryBox: LatLngBounds,
    projectBusinessLogicFilter: ProjectBusinessLogicFilterModel,
    extraParams: MapGeoDataParams | null,
  ): Observable<Array<any>> {
    let params = new HttpParams()
      .append('page', '1')
      .append('per-page', '1000')
      .append(this.buildRegionGeofenceSumSearchKey('min_lat'), checkLatValue('min', leafletBoundaryBox.getSouth()).toString())
      .append(this.buildRegionGeofenceSumSearchKey('min_lon'), checkLonValue('min', leafletBoundaryBox.getWest()).toString())
      .append(this.buildRegionGeofenceSumSearchKey('max_lat'), checkLatValue('max', leafletBoundaryBox.getNorth()).toString())
      .append(this.buildRegionGeofenceSumSearchKey('max_lon'), checkLonValue('max', leafletBoundaryBox.getEast()).toString());
    if (projectBusinessLogicFilter) {
      if (projectBusinessLogicFilter.project_id !== null) {
        params = params.append(this.buildRegionGeofenceSumSearchKey('project_id'), projectBusinessLogicFilter.project_id.toString());
      }
      if (projectBusinessLogicFilter.business_logic_id !== null) {
        params = params.append(this.buildRegionGeofenceSumSearchKey('business_logic_id'),
          projectBusinessLogicFilter.business_logic_id.toString());
      }
    }
    if (extraParams) {
      Object.entries(extraParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params = params.append(this.buildRegionGeofenceSumSearchKey(key), value.toString());
        }
      });
    }
    return this.http.get<Array<any>>(
      environment.apiBasepoint + 'region-geofence-sum',
      {observe: 'body', params: params}
    );
  }
}
